import React from 'react';
import cx from 'classnames';

import { centsToCurrency } from '~/utils/numbers';

import styles from '~/components/modals/product-details/price.module.scss';

const Price = ({
  inStock,
  fullPrice,
  unitPrice,
  className,
  discountPriceClassName,
}) => {
  const regularPrice = (
    <p className={cx(styles.price, className)}>
      {centsToCurrency(fullPrice, { round: true })}
    </p>
  );

  const discountPrice = (
    <div className={cx(styles.discountPriceContainer, discountPriceClassName)}>
      <p className={styles.price}>
        <span className={styles.salePrice}>
          {centsToCurrency(unitPrice, { round: true })}
        </span>
        <span className={styles.fullPrice}>
          {centsToCurrency(fullPrice, { round: true })}
        </span>
      </p>
    </div>
  );

  if (inStock === false) {
    return regularPrice;
  } else if (unitPrice === fullPrice) {
    return regularPrice;
  } else return discountPrice;
};

export default Price;
